import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Image, Responsive, Button, Modal } from 'semantic-ui-react';
import { getAssets } from '../../selectors';
import { resetState } from '../../actions';
import i18next from 'i18next';
import LanguagePicker from './LanguagePicker';
import Confirmation from '../general/Confirmation';
import ResetButton from './ResetButton';
import BranchCard from '../branches/BranchCard';
import Announcements from './Announcements';

import './Header.scss';

const AppHeader = () => {
    const [showModal, setShowModal] = useState(false);
    const dispatch = useDispatch();
    const title = useSelector(state => state.app.pageTitle);
    const cartId = useSelector(state => !!state.order.cart.cartId);
    const tableNumber = useSelector(state => state.order.tableNumber);
    const announcements = useSelector(state => state.catalog.announcements);
    const { logo } = useSelector(getAssets);
    const history = useHistory();

    const handleConfirmReset = () => {
        setShowModal(false);
        dispatch(resetState());
    };

    const handleResetClick = () => {
        if (cartId || window.location.pathname !== '/') {
            setShowModal(true);
        }
    };

    return (
        <div>
            <div className="pi-header" >
                <div className="col-1">
                    {logo && <Image className="logo" src={logo} onClick={handleResetClick} />}
                </div>
                <div className="col-2">
                    <span className="page-title">
                        {tableNumber && title ?
                            i18next.t('orderTypes.sitting', { tableNumber, context: tableNumber ? 'tablenumber' : null })
                            :
                            i18next.t(title)
                        }
                    </span>
                </div>
                <div className="col-3">
                    {history.location.pathname === '/order' && (
                        <Responsive maxWidth={768}>
                            <Modal trigger={<Button className="branch-info" icon="info" circular />}>
                                <Modal.Content>
                                    <BranchCard />
                                </Modal.Content>
                            </Modal>
                        </Responsive>)
                    }
                    <ResetButton onClick={handleResetClick} />
                    <LanguagePicker />
                </div>
                <Confirmation open={showModal} onConfirm={handleConfirmReset} onCancel={() => setShowModal(false)} />
            </div>
            {/* {!tableNumber ? null :
                <div className="pi-header-table-label">
                    {i18next.t('orderTypes.sitting', { tableNumber, context: tableNumber ? 'tablenumber' : null })}
                </div>
            } */}
            <div className="pi-announcements-container">
                {announcements && history.location.pathname === '/order' && <Announcements announcements={announcements} />}
            </div>
        </div>
    );
};

export default AppHeader;
